import axios from 'axios';
import store from '@/store';
import { UnauthorizedError } from '@/errors/UnauthorizedError';
import { UnauthenticatedError } from '@/errors/UnauthenticatedError';
import { NotFoundError } from '@/errors/NotFoundError';

function handleErrorResponseCode(err, method, params) {
  if (err.response.status === 403)
    throw new UnauthorizedError(`${method}('${params}') unauthorized`);

  if (err.response.status === 401)
    throw new UnauthenticatedError(`${method}('${params}') unauthenticated`);

  if (err.response.status === 404) throw new NotFoundError(`${method}('${params}') not found`);

  throw new Error(`ERROR @${method}('${params}')`);
}

function httpMethodBuilder(axiosMethod, init) {
  return async (context, path, data) => {
    console.debug(`>> ${context}@${axiosMethod.toUpperCase()}`, path, data);
    try {
      init(axios, store.state.idToken);
      let response = await axios[axiosMethod](path, data);
      console.debug(
        `<< ${context}@${axiosMethod.toUpperCase()} : ${response.request.responseURL} : response`,
        response
      );
      return response.data;
    } catch (err) {
      console.debug(err);
      handleErrorResponseCode(err, context, data);
    }
  };
}

/**
 * HTTP method calls
 */
export default init => ({
  get: httpMethodBuilder('get', init),

  post: httpMethodBuilder('post', init),

  put: httpMethodBuilder('put', init),

  patch: httpMethodBuilder('patch', init),

  delete: httpMethodBuilder('delete', init),
});
